<template>
  <div class="kt-portlet kt-portlet--mobile">
    <!--begin::Form-->
    <form class="kt-form" ref="form" @submit.prevent="formSubmit($event)">
      <div class="kt-portlet__head kt-portlet__head--lg">
        <div class="kt-portlet__head-label">
          <span class="kt-portlet__head-icon">
            <i class="kt-font-brand flaticon-home"></i>
          </span>
          <h3 class="kt-portlet__head-title">{{this.$route.meta.breadcrumb}}</h3>
        </div>
      </div>
      <div class="kt-portlet__body">
        <div class="kt-section kt-section--first">
          <div class="row">
            <!-- Begin:ชื่องบประมาณ  -->
            <div class="col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6">
              <div class="form-group">
                <label class="label-required">ชื่องบประมาณ :</label>
                <input
                  id="bcBudgetName"
                  name="bcBudgetName"
                  v-model="bcBudgetName"
                  type="text"
                  maxlength="450"
                  class="form-control"
                  placeholder="ชื่องบประมาณ"
                />
                <span class="form-text"></span>
              </div>
            </div>
            <!-- End:แบรนด์สินค้า select2 -->
            <!-- Begin:ประเภทงบประมาณ select2 -->
            <div class="col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6">
              <div class="form-group">
                <label class="label-required">ประเภทงบประมาณ :</label>
                <select2
                  :class="'form-control m-select2'"
                  :style="'width: 100%;'"
                  :id="'bcBudgetType'"
                  :name="'bcBudgetType'"
                  :select2-options="bcBudgetTypeOptions"
                  v-model="bcBudgetType"
                  ref="BcBudgetTypeSelect2"
                ></select2>
                <span class="form-text"></span>
              </div>
            </div>
            <!-- End:ประเภทงบประมาณ select2 -->

            <!-- Begin:งบประมาณ input -->
            <div class="col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6">
              <div class="form-group">
                <label class="label-required">งบประมาณ :</label>
                <currency-input
                  class="form-control"
                  v-model="bcBudget"
                  id="bcBudget"
                  name="bcBudget"
                  v-currency="{locale, currency}"
                  auto-decimal-mode:true
                  placeholder="งบประมาณ"
                />
                <span class="form-text"></span>
              </div>
            </div>
            <!-- End:งบประมาณ input -->

            <!-- Begin:ใช้ไป input -->
            <div class="col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6">
              <div class="form-group">
                <label class="label">ใช้ไป :</label>
                <span class="form-control-plaintext">{{ bcUsed | currency('฿')}}</span>
              </div>
            </div>
            <!-- End:ใช้ไป input -->

            <!-- Begin:คงเหลือ input -->
            <div class="col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6">
              <div class="form-group">
                <label class="label">คงเหลือ :</label>
                <span class="form-control-plaintext">{{ BcBalanceCal | currency('฿')}}</span>
              </div>
            </div>
            <!-- End:คงเหลือ input -->
            <!-- Begin:ปี input -->
            <div class="col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6">
              <div class="form-group">
                <label class="label-required">ปี :</label>
                <datepicker
                  :format="DatePickerFormat"
                  minimum-view="year"
                  name="bcYear"
                  id="bcYear"
                  v-model="bcYear"
                  input-class="form-control"
                ></datepicker>
                <span class="form-text"></span>
              </div>
            </div>
            <!-- End:ปี input -->

            <div class="col-xl-3">
              <div class="form-group">
                <label>สถานะ:</label>
                <div class="form-check">
                  <label class="form-check-label kt-checkbox">
                    <input
                      id="bcStatus"
                      name="bcStatus"
                      v-model="bcStatus"
                      type="checkbox"
                      class="form-check-input"
                    />
                    เปิดใช้งาน
                    <span></span>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="kt-portlet__foot">
        <button
          type="button"
          class="btn btn-secondary"
          data-dismiss="modal"
          @click="$router.go(-1)"
        >
          <i class="la la-close"></i> ย้อนกลับ
        </button>
        <button type="submit" class="btn btn-primary" data-dismiss="modal">
          <i class="la la-save"></i> บันทึกข้อมูล
        </button>
      </div>
    </form>
    <!--end::Form-->
  </div>
</template>

<script>
import axios from "axios";
import select2 from "../../../Shared/Select2";
import Vue from "vue";
import VueCurrencyInput from "vue-currency-input";
import Vue2Filters from "vue2-filters";
import Datepicker from "vuejs-datepicker";

Vue.use(VueCurrencyInput);
Vue.use(Vue2Filters);

export default {
  components: {
    select2,
    Datepicker
  },
  data() {
    var self = this;
    return {
      DatePickerFormat: "yyyy",
      locale: "th",
      currency: "THB",
      bcBudgetName: null,
      bcProductBrandId: null,
      bcBudgetType: null,
      bcBudget: null,
      bcUsed: 0,
      bcBalance: null,
      bcYear: null,
      bcStatus: true, //init checkbox
      bcProductBrandIdOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/ProductBrand/Select2ProductBrand",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1
            };
            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      bcBudgetTypeOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/Variables/Options",
          data: function(params) {
            var query = {
              search: "BUDGET_TYPE",
              page: params.page || 1
            };
            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      }
    };
  },
  computed: {
    BcBalanceCal() {
      this.bcBalance =
        this.bcUsed != null ? this.bcBudget - this.bcUsed : this.bcBudget;
      return this.bcBalance;
    }
  },
  methods: {
    formSubmit: function(e) {
      let router = this.$router;
      let self = this;

      if (
        !$(this.$refs.form)
          .validate()
          .form()
      ) {
        return false;
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังบันทึกข้อมูล กรุณารอสักครู่..."
      });

      axios
        .post("/Api/BudgetBrand", {
          BudgetName: self.bcBudgetName,
          BudgetType: self.bcBudgetType,
          Year: self.bcYear.getFullYear(),
          Budget: self.bcBudget,
          UsedAmout: self.bcUsed,
          Balance: self.bcBalance,
          InActiveStatus: !self.bcStatus
        })
        .then(function(response) {
          if (response.data.status) {
            KTApp.unblockPage();
            Swal.fire("สำเร็จ", response.data.message, "success").then(
              function() {
                router.go(-1), self.$parent.reloadDataTable(false);
              }
            );
          } else {
            //console.log(response);
            Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
          }
        })
        .catch(function(error) {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        })
        .then(function() {
          // always executed
          KTApp.unblockPage();
        });
    }
  },
  async mounted() {
    let self = this;

    //set Current Year
    this.bcYear = new Date();
    $(this.$refs.form).validate({
      rules: {
        bcBudgetName: "required",
        bcBudgetType: "required",
        bcBudget: "required",
        bcYear: "required"
      },
      messages: {
        bcBudgetName: "กรุณาระบุชื่องบประมาณ",
        bcBudgetType: "กรุณาเลือกประเภทงบประมาณ",
        bcBudget: "กรุณาระบุงบประมาณ",
        bcYear: "กรุณาระบุปีงบประมาณ"
      }
    });

    $(this.$refs.form).validate().settings.ignore = ":hidden";
  }
};
</script>


// WEBPACK FOOTER //
// App/Components/Master/Brand/BrandCreate.vue